import { render, staticRenderFns } from "./BaseStationCard.vue?vue&type=template&id=ed3a7abc&scoped=true&"
import script from "./BaseStationCard.vue?vue&type=script&lang=js&"
export * from "./BaseStationCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseStationCard.vue?vue&type=style&index=0&id=ed3a7abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3a7abc",
  null
  
)

export default component.exports